// 1 general
// 2 salon
// 3 education
// 4 rentcar
// 5 cleaning
// 6 contracting
// 7 realestate
// 8 services
// 9 delivery

export const templates = [
  {
    id: 1,
    title: 'general',
    name: 'General Template',
    nameAr: 'النموذج العام',
    options: {
      project: true,
      contract: true,
      resourse: true,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: false,
      dayCost: false,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: true,
      overtime: true,
      absent: true,
      location: true,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: true,
      workId: true,
      target: true,
      city: false,
      address: false,
      color: true,
      status: true,
      carstatus: false,
      garage: false,
      brand: false,
      model: false,
      plate: false,
      cost: true,
      purtime: true,
      insurance: false,
      licenseDate: false,
      photos: true,
      location: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: false,
      national: false,
      nationalNo: true,
      nationalDate: true,
      licenseNo: false,
      licenseDate: false,
      startWorkDate: false,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: true,
      tel: false,
      fax: false,
      mobile: true,
      email: true,
      city: false,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'الموعد',
        appointments: 'المواعيد',
        eventsitems: 'بنود المواعيد',
        invoicesitems: 'بنود الفواتير',
        task: 'المهمة',
        tasks: 'المهام',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'المورد',
        resourses: 'الموارد',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Appointment',
        appointments: 'Appointments',
        eventsitems: 'Appoint Items',
        invoicesitems: 'Invoice Items',
        task: 'Task',
        tasks: 'Tasks',
        department: 'Department',
        departments: 'Departments',
        customer: 'Customer',
        suppliers: 'Suppliers',
        customers: 'Customers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Resourse',
        resourses: 'Resourses',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
  {
    id: 2,
    title: 'salon',
    name: 'Salon Template',
    nameAr: 'نموذج صالون ',
    options: {
      project: false,
      contract: true,
      resourse: false,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: false,
      dayCost: false,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: false,
      overtime: false,
      absent: false,
      location: true,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: false,
      workId: false,
      target: false,
      city: false,
      address: false,
      color: false,
      status: false,
      carstatus: false,
      garage: false,
      brand: false,
      model: false,
      plate: false,
      cost: false,
      purtime: false,
      insurance: false,
      licenseDate: false,
      photos: false,
      location: false,
      department: false,
      retype: false,
      info: false,
      disabled: false,
      note: false,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: true,
      national: true,
      nationalNo: true,
      nationalDate: true,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: false,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'الموعد',
        appointments: 'المواعيد',
        eventsitems: 'بنود المواعيد',
        invoicesitems: 'بنود الفواتير',
        task: 'كورس',
        tasks: 'الكورسات',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'المورد',
        resourses: 'الموارد',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Appointment',
        appointments: 'Appointments',
        eventsitems: 'Appoint Items',
        invoicesitems: 'Invoice Items',
        task: 'Task',
        tasks: 'Tasks',
        department: 'Department',
        departments: 'Departments',
        customer: 'Customer',
        customers: 'Customers',
        suppliers: 'Suppliers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Resourse',
        resourses: 'Resourses',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
  {
    id: 3,
    title: 'education',
    name: 'Education Template',
    nameAr: 'نموذج مركز تعليمي',
    options: {
      project: false,
      contract: true,
      resourse: false,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: false,
      dayCost: false,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: false,
      overtime: false,
      absent: false,
      location: true,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: false,
      workId: false,
      target: true,
      city: false,
      address: false,
      color: false,
      status: true,
      carstatus: false,
      garage: false,
      brand: false,
      model: false,
      plate: false,
      cost: false,
      purtime: false,
      insurance: false,
      licenseDate: false,
      photos: false,
      location: false,
      department: true,
      retype: true,
      info: false,
      disabled: false,
      note: false,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: true,
      national: true,
      nationalNo: false,
      nationalDate: false,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: true,
      nationalNo: true,
      nationalDate: true,
      parentName: true,
      parentPhone: true,
      grade: true,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'حصة',
        appointments: 'حصص',
        eventsitems: 'بنود الحصص',
        invoicesitems: 'بنود الفواتير',
        task: 'الكورس',
        tasks: 'الكورسات',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'الطالب',
        customers: 'الطلاب',
        suppliers: 'الموردين',
        employee: 'المدرس',
        employees: 'المدرسين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'المورد',
        resourses: 'الموارد',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Lesson',
        appointments: 'Lessons',
        eventsitems: 'Lessons Items',
        invoicesitems: 'Invoice Items',
        task: 'Course',
        tasks: 'Courses',
        department: 'Department',
        departments: 'Departments',
        customer: 'Student',
        customers: 'Students',
        suppliers: 'Suppliers',
        employee: 'Teacher',
        employees: 'Teachers',
        employee2: 'Teacher',
        employees2: 'Teachers',
        resourse: 'Resourse',
        resourses: 'Resourses',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
  {
    id: 4,
    title: 'rentcar',
    name: 'Rent Car Template',
    nameAr: 'نموذج شركة تأجير سيارات',
    options: {
      project: false,
      contract: true,
      resourse: true,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: false,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: true,
      dayCost: true,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: false,
      overtime: false,
      absent: false,
      location: false,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: true,
      workId: true,
      target: true,
      city: false,
      address: false,
      color: true,
      status: true,
      carstatus: true,
      garage: true,
      brand: true,
      model: true,
      plate: true,
      cost: true,
      purtime: true,
      insurance: true,
      licenseDate: true,
      photos: true,
      location: false,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: true,
      licenseNo: true,
      licenseDate: true,
      national: true,
      nationalNo: true,
      nationalDate: true,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'الموعد',
        appointments: 'المواعيد',
        eventsitems: 'بنود المواعيد',
        invoicesitems: 'بنود الفواتير',
        task: 'العقد',
        tasks: 'العقود',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'السيارة',
        resourses: 'السيارات',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Appointment',
        appointments: 'Appointments',
        eventsitems: 'Appoint Items',
        invoicesitems: 'Invoice Items',
        task: 'Contract',
        tasks: 'Contracts',
        department: 'Department',
        departments: 'Departments',
        customer: 'Customer',
        customers: 'Customers',
        suppliers: 'Suppliers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Car',
        resourses: 'Cars',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
  {
    id: 5,
    title: 'cleaning',
    name: 'Cleaning Template',
    nameAr: 'نموذج شركة نظافة',
    options: {
      project: false,
      contract: true,
      resourse: true,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: false,
      dayCost: false,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: true,
      overtime: false,
      absent: false,
      location: true,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: true,
      workId: true,
      target: true,
      city: false,
      address: false,
      color: true,
      status: true,
      carstatus: false,
      garage: false,
      brand: false,
      model: false,
      plate: false,
      cost: true,
      purtime: true,
      insurance: true,
      licenseDate: false,
      photos: true,
      location: false,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: true,
      national: true,
      nationalNo: false,
      nationalDate: false,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'الموعد',
        appointments: 'المواعيد',
        eventsitems: 'بنود المواعيد',
        invoicesitems: 'بنود الفواتير',
        task: 'المهمة',
        tasks: 'المهام',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'المورد',
        resourses: 'الموارد',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'خدمة',
        services: 'خدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Appointment',
        appointments: 'Appointments',
        eventsitems: 'Appoint Items',
        invoicesitems: 'Invoice Items',
        task: 'Task',
        tasks: 'Tasks',
        department: 'Project',
        departments: 'Projects',
        customer: 'Customer',
        customers: 'Customers',
        suppliers: 'Suppliers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Resourse',
        resourses: 'Resourses',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
  {
    id: 6,
    title: 'contracting',
    name: 'Contracting',
    nameAr: 'نموذج شركة مقاولات',
    options: {
      project: false,
      contract: true,
      resourse: false,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: false,
      dayCost: false,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: true,
      overtime: true,
      absent: true,
      location: true,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: true,
      workId: true,
      target: true,
      city: false,
      address: false,
      color: true,
      status: true,
      carstatus: true,
      garage: true,
      brand: true,
      model: true,
      plate: true,
      cost: true,
      purtime: true,
      insurance: true,
      licenseDate: true,
      photos: true,
      location: false,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: true,
      national: true,
      nationalNo: false,
      nationalDate: false,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'النشاط',
        appointments: 'الانشطة',
        eventsitems: 'بنود الانشطة',
        invoicesitems: 'بنود الفواتير',
        task: 'العقد',
        tasks: 'العقود',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'المعدة',
        resourses: 'المعدات',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'الشقة',
        evretype2: 'الغرفة',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Activity',
        appointments: 'Activities',
        eventsitems: 'Activities Items',
        invoicesitems: 'Invoice Items',
        task: 'Contract',
        tasks: 'Contracts',
        department: 'Department',
        departments: 'Departments',
        customer: 'Customer',
        suppliers: 'Suppliers',
        customers: 'Customers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Equipment',
        resourses: 'Equipments',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'Flat',
        evretype2: 'Room',
      },
    },
  },
  {
    id: 7,
    title: 'realestate',
    name: 'Real Estate Template',
    nameAr: 'نموذج شركة عقارات',
    options: {
      project: false,
      contract: true,
      resourse: true,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: true,
      dayCost: true,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: false,
      overtime: false,
      absent: false,
      location: false,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: true,
      workId: true,
      target: true,
      city: true,
      address: true,
      color: false,
      status: true,
      carstatus: false,
      garage: false,
      brand: false,
      model: false,
      plate: false,
      cost: false,
      purtime: false,
      insurance: false,
      licenseDate: false,
      photos: true,
      location: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: true,
      national: true,
      nationalNo: false,
      nationalDate: false,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: false,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: false,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'الموعد',
        appointments: 'المواعيد',
        eventsitems: 'بنود المواعيد',
        invoicesitems: 'بنود الفواتير',
        task: 'العقد',
        tasks: 'العقود',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'العقار',
        resourses: 'العقارات',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Appointment',
        appointments: 'Appointments',
        eventsitems: 'Appoint Items',
        invoicesitems: 'Invoice Items',
        task: 'Contract',
        tasks: 'Contracts',
        department: 'Department',
        departments: 'Departments',
        customer: 'Customer',
        suppliers: 'Suppliers',
        customers: 'Customers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Real Esate',
        resourses: 'Real Esates',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
  {
    id: 8,
    title: 'services',
    name: 'Services Template',
    nameAr: 'نموذج شركة خدمات',
    options: {
      project: false,
      contract: true,
      resourse: true,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: true,
      dayCost: true,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: true,
      overtime: false,
      absent: false,
      location: true,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: true,
      workId: true,
      target: true,
      city: false,
      address: false,
      color: true,
      status: true,
      carstatus: false,
      garage: false,
      brand: false,
      model: false,
      plate: false,
      cost: true,
      purtime: true,
      insurance: false,
      licenseDate: false,
      photos: true,
      location: false,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: true,
      national: true,
      nationalNo: false,
      nationalDate: false,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: false,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'الموعد',
        appointments: 'المواعيد',
        eventsitems: 'بنود المواعيد',
        invoicesitems: 'بنود الفواتير',
        task: 'العقد',
        tasks: 'العقود',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'المورد',
        resourses: 'الموارد',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Appointment',
        appointments: 'Appointments',
        eventsitems: 'Appoint Items',
        invoicesitems: 'Invoice Items',
        task: 'Contract',
        tasks: 'Contracts',
        department: 'Department',
        departments: 'Departments',
        customer: 'Customer',
        customers: 'Customers',
        suppliers: 'Suppliers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Resourse',
        resourses: 'Resourses',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
  {
    id: 9,
    title: 'delivery',
    name: 'Delivery Template',
    nameAr: 'نموذج شركة التوصيل',
    options: {
      project: false,
      contract: true,
      resourse: true,
      employee: true,
      department: true,
      retype: true,
      retype2: true,
      calendar: true,
      emplcalendar: true,
      expenses: true,
      purchase: true,
      sms: true,
      reminder: true,
      itemdepartempl: true,
      docrelations: true,
      itemrelations: true,
      itemdescription: true,
      invoiceitemrelations: true,
      expensesitemrelations: true,
      purchaseitemrelations: true,
      proexpensesitemrelations: true,
      cashinvoice: true,
      additionId: true,
      barcode: true,
      events: true,
      brand: true,
      category: true,
      section: false,
      accountant: true,
      notification: true,
      contracting: false,
      products: true,
      productsdef: false,
      docdescription: false,
      invoicetip: false,
      tirms: false,
      emailnotification: false,
      groupinvoice: false,
      shortinvoice: false,
      resoursesavailable: false,
      customersmenu: false,
      employeesmenu: false,
      resoursesmenu: false,
      departmentsmenu: false,
      dublicatename: true,
      dublicatephone: true,
      shortemployee: false,
      shortcustomer: false,
      nameonelang: false,
      taskendlastevent: false,
      livedata: false,
      tempevent: false,
      pageall: false,
      pinvoiceattach: false,
      expenseattach: false,
      receiptattach: false,
      eventattach: false,
      formdocs: false,
      procedures: false,
      calendarclock: false,
      dochirtory: false,
      letters: false,
      presales: false,
      reports: false,
      operations: false,
      sales: false,
      finance: false,
      mail: false,
      pos: false,
      posprod: false,
      posserv: false,
      contractsalescalc: false,
    },
    calendaroptions: {
      emplfilter: true,
      departfilter: true,
      statusfilter: true,
    },
    taskoptions: {
      info: false,
      dayCost: false,
      note: true,
      endrequire: true,
      notefyonend: true,
      events: true,
      items: true,
      itemsrequire: false,
      customer: true,
      customerrequire: false,
      employee: true,
      employeerequire: false,
      department: true,
      resourse: true,
      resourserequire: false,
      desc: true,
      printdate: true,
      printtitle: false,
      address: true,
      extra: true,
      deposit: true,
      ismemorized: true,
      retype: false,
      retype2: false,
      tasktype: false,
      time: false,
      tasktitle: false,
      taskfree: false,
      duration: false,
      photos: false,
    },
    eventoptions: {
      bonos: false,
      overtime: false,
      absent: false,
      location: true,
      retype: true,
      retype2: true,
      status: true,
      newinvoice: true,
      note: true,
      title: true,
      sms: true,
      retypefilter: false,
      retype2filter: false,
      customerfilter: false,
      employeefilter: false,
      dueeventscheck: false,
      noinvoicecheck: false,
      multievents: false,
      duetoday: false,
      driverbox: false,
    },
    resorseoptions: {
      additionId: true,
      workId: true,
      target: true,
      city: false,
      address: false,
      color: true,
      status: true,
      carstatus: true,
      garage: true,
      brand: true,
      model: true,
      plate: true,
      cost: true,
      purtime: true,
      insurance: true,
      licenseDate: true,
      photos: true,
      location: false,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
    },
    employeeoptions: {
      additionId: true,
      target: true,
      workId: true,
      telHome: true,
      national: true,
      nationalNo: true,
      nationalDate: true,
      licenseNo: true,
      licenseDate: true,
      startWorkDate: true,
      basicSalary: true,
      extraSalary: true,
      daysoff: true,
      speciality: true,
      color: true,
      tel: true,
      fax: false,
      mobile: true,
      email: true,
      city: true,
      address: true,
      pId: true,
      pIdDate: true,
      photos: true,
      location: true,
      comPercent: true,
      department: true,
      retype: true,
      info: false,
      disabled: true,
      note: true,
      team: false,
      salsales: true,
      salevents: false,
      salexpenses: false,
      salbonos: true,
      salovertime: true,
      salabsent: true,
      birthday: true,
      salworkpercent: false,
      salsalespercent: false,
      salextra: false, // بدلات
    },
    departmentoptions: {
      additionId: true,
      target: true,
      color: true,
      desc: true,
      retype: true,
      disabled: true,
      note: true,
    },
    customeroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      area: true,
      driver: false,
      licenseNo: false,
      licenseDate: false,
      national: false,
      nationalNo: false,
      nationalDate: false,
      parentName: false,
      parentPhone: false,
      grade: false,
      location: true,
      disabled: true,
      birthday: true,
      openingbalance: true,
      note: true,
      employee: true,
    },
    supplieroptions: {
      additionId: true,
      tel: true,
      fax: true,
      mobile: true,
      email: true,
      city: true,
      address: true,
      balance: true,
      disabled: true,
      openingbalance: true,
      note: true,
    },
    tabsemployee: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      advanced: true,
      custody: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsdepartment: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabsresourse: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    tabscustomer: {
      main: true,
      projects: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
    },
    tabssupplier: {
      main: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesitems: true,
    },
    tabsproject: {
      main: true,
      tasks: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
    },
    tabstask: {
      main: true,
      events: true,
      eventsitems: true,
      invoices: true,
      invoicesitems: true,
      receipts: true,
      purchases: true,
      payments: true,
      expenses: true,
      expensesprod: true,
      entries: true,
      reminders: true,
      expensesitems: true,
    },
    mpagemain: {
      appointment: true,
      days: true,
      sales: true,
      purchase: true,
      expenses: true,
      kaids: true,
      income: true,
      raseed: true,
      salary: true,
    },
    hiddencolumns: {
      task: [],
      appointment: [],
      resourse: [],
      employee: [],
      department: [],
      invoice: [],
      receipt: [],
      customer: [],
      pruchaseinvoice: [],
      payment: [],
      supplier: [],
      expenses: [],
      prodexpenses: [],
      advancedpay: [],
      advancedrec: [],
      finance: [],
      kaid: [],
      type: [],
      service: [],
      product: [],
      expenseitem: [],
      reminder: [],
      user: [],
      notification: [],
    },
    mainPage: [],
    taskExtra: [
      {
        id: 1,
        name: 'Kilometer out',
        nameAr: 'العداد وقت الخروج',
        type: 'text',
        value: '',
      },
      {
        id: 2,
        name: 'Kilometer in',
        nameAr: 'العداد وقت العودة',
        type: 'text',
        value: '',
      },
      {
        id: 3,
        name: 'Notes',
        nameAr: 'ملاحظات',
        type: 'text',
        multiline: true,
        value: '',
      },
    ],
    emplExtra: [],
    resoExtra: [],
    custExtra: [],
    sortOrder: [0, 0.5, 0.55, 0.56, 0.6, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    words: {
      ar: {
        main: 'الرئيسية',
        operation: 'العملية',
        operations: 'العمليات',
        appointment: 'الموعد',
        appointments: 'المواعيد',
        eventsitems: 'بنود المواعيد',
        invoicesitems: 'بنود الفواتير',
        task: 'المهمة',
        tasks: 'المهام',
        department: 'القسم',
        departments: 'الأقسام',
        customer: 'العميل',
        customers: 'العملاء',
        suppliers: 'الموردين',
        employee: 'الموظف',
        employees: 'الموظفين',
        employee2: 'الموظف',
        employees2: 'الموظفين',
        resourse: 'المركبة',
        resourses: 'المركبات',
        project: 'المشروع',
        projects: 'المشاريع',
        service: 'الخدمة',
        services: 'الخدمات',
        expenseitems: 'المصروف',
        retype: 'نوع',
        evretype: 'نوع الموعد',
        evretype2: 'نوع الموعد 2',
      },
      en: {
        main: 'Main',
        operation: 'Operation',
        operations: 'Operations',
        appointment: 'Appointment',
        appointments: 'Appointments',
        eventsitems: 'Appoint Items',
        invoicesitems: 'Invoice Items',
        task: 'Job',
        tasks: 'Jobs',
        department: 'Department',
        departments: 'Departments',
        customer: 'Customer',
        customers: 'Customers',
        suppliers: 'Suppliers',
        employee: 'Employee',
        employees: 'Employees',
        employee2: 'Employee',
        employees2: 'Employees',
        resourse: 'Vehicle',
        resourses: 'Vehicles',
        project: 'Project',
        projects: 'Projects',
        service: 'Service',
        services: 'Services',
        expenseitems: 'Expenses Items',
        retype: 'Type',
        evretype: 'ُEType1',
        evretype2: 'Etype2',
      },
    },
  },
];
